export default {
  hcaptcha: 'hCaptcha',
  arkose: 'arkose',
};
